import React, {useState, useRef, useEffect} from 'react'
/** @jsxImportSource @emotion/react */
import {css} from '@emotion/react'

import useMediaQuery from '@mui/material/useMediaQuery'

import {useResize} from '../../../hooks'

import CalendarHeader from './CalendarHeader'
import CalendarDayNames from './CalendarDayNames'
import CalendarDays from './CalendarDays'




const cssStyles = ({isExtraSmallScreen}) => {
  return {
    root: css`
      width: 100%;
      max-width: 370px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      padding: ${isExtraSmallScreen ? '7px' : '20px'};
    `
  }
}


const Calendar = props => {

  const ref = useRef(null)

  const dimensions = useResize(ref)

  const isExtraSmallScreen = useMediaQuery(theme => theme.breakpoints.only('xs'))

  const styles = cssStyles({isExtraSmallScreen})

  const [width, setWidth] = useState(300)

  const {callback, start, end, isRange, isToday, isActive} = props

  const [selectedDate, setSelectedDate] = useState((start instanceof Date) ? start : new Date())



  useEffect(() => {
    if (isExtraSmallScreen) {  
      setWidth(dimensions.width - 50)
    } else if (dimensions.width && dimensions.width > 200) {
      setWidth(Math.min(300, dimensions.width))
    } 
  }, [dimensions.width, isExtraSmallScreen])



  useEffect(() => {
    if (isToday) {
      setSelectedDate(new Date())
    }
  }, [isToday])



  return (
    <div ref={ref} css={styles.root}>
      <div style={{width: width}}>
        <CalendarHeader 
          date={selectedDate} 
          setDate={setSelectedDate} 
        />

        <CalendarDayNames 
          date={selectedDate } 
          containerWidth={width} 
        />

        <CalendarDays 
          start={start}
          end={end}
          date={selectedDate} 
          isRange={isRange} 
          isActive={isActive}
          callback={callback}
          containerWidth={width}
        />
      </div>
    </div>
  )
}

export default Calendar



